/**
 * Display formatters shared by ``CenterBookPanel`` (full widgets) and
 * ``MobileBottomBar`` (compact chips).  Kept in its own module so the
 * panel file can stay component-only -- React Fast Refresh wants a
 * single concern per file.
 */

export function formatMillions(rub: number): string {
  if (Math.abs(rub) >= 1_000_000) return `${(rub / 1_000_000).toFixed(2)}M`;
  if (Math.abs(rub) >= 1_000) return `${(rub / 1_000).toFixed(0)}k`;
  return String(Math.round(rub));
}

export function formatPct(fraction: number, digits = 1): string {
  return `${(fraction * 100).toFixed(digits)}%`;
}

export function signedPct(fraction: number): string {
  return `${fraction >= 0 ? '+' : ''}${formatPct(fraction)}`;
}

export function signedM(rub: number): string {
  return `${rub >= 0 ? '+' : ''}₽${formatMillions(rub)}`;
}
